export default __webpack_public_path__ + "static/media/youtube-icon.cd6b48e9.svg";